
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ffc107","d":"M37 45H11a3 3 0 01-3-3V6a3 3 0 013-3h19l10 10v29a3 3 0 01-3 3z"}}),_c('path',{attrs:{"fill":"#ffecb3","d":"M40 13H30V3z"}}),_c('path',{attrs:{"fill":"#ffa000","d":"M30 13l10 10V13z"}}),_c('path',{attrs:{"fill":"#fff","d":"M30 22H18c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V24c0-1.1-.9-2-2-2zm0 4v8H18v-8h12z"}})])
          )
        }
      }
    